import { ref } from 'vue'
import { OrderRequestParams, OrderState } from '/@src/models/api'
import { getOrderList } from '/@src/api/orderRepo'
import { useI18n } from 'vue-i18n'
import { getThisMonday } from '/@src/utils/date'
import {OrderChartData} from "/@src/models/order";
import useApi from "/@src/composable/useApi";
import {setupAmountChartOption, setupOrderChartOption, setupOrderTypesChartOptions} from '/@src/utils/setChartOptions'

export default function useOrderAnalytics(isShowTitle:boolean = true) {
  const orderAnalyticsResponse = ref<OrderChartData>()
  const api = useApi()
  const salesChartOptions = ref({})
  const orderChartOptions = ref({})
  const orderTypeChartOptions = ref({})
  const { t, locale } = useI18n()
  /**
   * 获得最近一个月的订单数据
   */
  const getRecentOrderDataList = async () => {
    // 获取30天前0点时间
    const start = new Date(new Date().toLocaleDateString())
    //29天前至当日，获取一个月订单数
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
    return getOrderDataList(start,new Date())
  }
  const getOrderDataList = (start?:Date,end?:Date) => {
    console.log(start)
    if(!start){
      start = new Date()
      start.setFullYear(2018,7,30)
    }
    start.setHours(0,0,0,0)
    if(!end){
      end = new Date()
    }
    const param: OrderRequestParams = {
      limit: 99999,
      state: OrderState.COMPLETE,
      timeStart: Math.floor((start.getTime() / 1000)).toString(),
      timeEnd: Math.floor(end.getTime() / 1000).toString(),
    }
    const dayDiff:number = Math.ceil((end.getTime() - start.getTime())/(1000 * 3600 *24))
    console.log(`dayDiff:${dayDiff}`)
    getOrderList(api, param).then((ret) => {
      orderAnalyticsResponse.value = {
        totalAmount: ret.total_amount,
        totalCount: ret.total_count,
        orders: new Array(dayDiff).fill(0),
        amounts: new Array(dayDiff).fill(0),
        orderTypes: new Map<string, number>(),
        lastWeekRevenue: 0,
        thisWeekRevenue: 0,
      }
      let arrayDate: Date = start!!
      let index = 0
      const lastMonday = new Date(
        getThisMonday().getTime() - 7 * 3600 * 24 * 1000
      )
      const thisMonday = getThisMonday()
      ret.items?.map((it) => {
        const currentDate = new Date(it.created_at)
        if (currentDate.getDate() === arrayDate.getDate()) {
          //同一天
          orderAnalyticsResponse.value!.amounts[index] += it.amount / 100
          orderAnalyticsResponse.value!.amounts[index] = parseFloat(
            orderAnalyticsResponse.value!.amounts[index].toFixed(2)
          )
        } else {
          //不同天，如果该日期无订单则自动调整到下一天
          while (currentDate.getDate() !== arrayDate.getDate()) {
            index++
            arrayDate = new Date(arrayDate.getTime() + 3600 * 1000 * 24)
          }
          orderAnalyticsResponse.value!.amounts[index] += it.amount / 100
          orderAnalyticsResponse.value!.amounts[index] = parseFloat(
            orderAnalyticsResponse.value!.amounts[index].toFixed(2)
          )
        }
        if (
          currentDate.getTime() >= lastMonday.getTime() &&
          currentDate.getTime() < thisMonday.getTime()
        ) {
          orderAnalyticsResponse.value!.lastWeekRevenue += it.amount / 100
        } else if (currentDate.getTime() > thisMonday.getTime()) {
          orderAnalyticsResponse.value!.thisWeekRevenue += it.amount / 100
        }

        orderAnalyticsResponse.value!.orders[index] += 1
        // 计算支付种类
        const typeCount = orderAnalyticsResponse.value!.orderTypes.get(it.title)
        if (!typeCount) {
          orderAnalyticsResponse.value!.orderTypes.set(it.title, 1)
        } else {
          orderAnalyticsResponse.value!.orderTypes.set(it.title, typeCount + 1)
        }
        // console.log(index)
      })
      salesChartOptions.value = setupAmountChartOption(
        isShowTitle,
        t,
        locale.value,
        orderAnalyticsResponse.value?.totalAmount,
        orderAnalyticsResponse.value?.amounts,
        start!!,
        dayDiff
      )
      orderChartOptions.value = setupOrderChartOption(
        t,
        locale.value,
        orderAnalyticsResponse.value?.totalCount,
        orderAnalyticsResponse.value?.orders,
        start!!,
        dayDiff
      )
      orderTypeChartOptions.value = setupOrderTypesChartOptions(
        orderAnalyticsResponse.value?.orderTypes,
        t,
        locale.value
      )
    })
  }
  return {
    orderAnalyticsResponse,
    salesChartOptions,
    orderChartOptions,
    orderTypeChartOptions,
    getRecentOrderDataList,
    getOrderDataList,
  }
}
